import { get } from 'lodash';
import { Coupon as CouponType } from 'src/types/Coupon';

// coupons for walmart must be called "discount cards" for legal reasons
export const getCouponTerm = (coupon?: CouponType) => {
  const isWalmart = !!get(coupon, 'pharmacy.is_walmart');
  const couponTerm = isWalmart ? 'discount card' : 'coupon';

  return couponTerm;
};
